import React from "react";
import { Helmet } from "react-helmet-async";
import { Breadcrumb, Col, Container, Row } from "react-bootstrap";
import Pricing from "../../components/pricing/Pricing";
import useBilling from "../../hooks/useBilling";
import { useTranslation } from "../../hooks/useLocalization";
import QDLoader from "../../components/QDLoader";
import { useNavigate } from "react-router-dom";

const PricingPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isInitialized, paymentsAvailable } = useBilling();
  return (
    <React.Fragment>
      <Helmet title={t("Packages & Prices")} />
      <Container fluid className="p-0">
        {/* <h1 className="h3 mb-3">{t("Packages & Prices")}</h1> */}
        {paymentsAvailable && (
          <Breadcrumb className="lead">
            <Breadcrumb.Item onClick={() => navigate("/account/payments")}>
              {t("Payments")}
            </Breadcrumb.Item>
            <Breadcrumb.Item active className="text-dark font-weight-bold">
              {t("Manage subscription")}
            </Breadcrumb.Item>
          </Breadcrumb>
        )}
        <Row>
          <Col md="12" className="mx-auto">
            {isInitialized ? <Pricing /> : <QDLoader />}
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default PricingPage;
